
export default {
    data() {
        return {
            isActive: false
        }
    },
    props: {
        title: String,
        text: String,
        button: Boolean,
        imgNumber: String,
        buttonFunc: {
            type: Function,
            default: () => true
        },
        additionalClass: {
            type: String,
            default: ''
        },
        isImg: {
            type: Boolean,
            default: false
        },
        toHeader:{
            type:Boolean,
            default:false
        }
    },
    computed: {
        src() {
            return require(`~/assets/img/baners/baner-${this.imgNumber}.webp`);
        }
    },
    
}
